import { IFaqChannel } from '@/models/faqChannel.model';

export const getFaqChannelBySlug = (channels: IFaqChannel[] | null | undefined, slug?: string) =>
  channels?.find((channel) => channel.slug === slug);
